import React, { Component } from 'react';
import apiInstance from '../apiInstance';
import { changeOverlayStatus } from '../../state/actionCreators/index'
import { connect } from 'react-redux';
import Button from '../Button';
import { formatDate } from '../Functions/formatDate';

class InstalledSitesPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widgetId: '',
            sites: [],
            displayPopup: false,
            error: '',
            isOpen : true,
        };
    }

    openPopup = (widgetId, sites,isOpen=true) => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                widgetId: widgetId,
                sites: sites,
                displayPopup: true,
                isOpen : isOpen ,
            })
        })
        this.props.changeOverlayStatus('true');
    }

    closePopup = () => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                widgetId: '',
                sites: [],
                displayPopup: false,
                error: ''
            })
        })
        this.props.changeOverlayStatus('false');
    }

    updateErrorMessage = (error = "", msg = "") => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                error: error,
                msg: msg
            })
        })
    }

    deleteSite = (siteId) => {

        const { widgetId } = this.state;
        apiInstance.delete(`/widget/${widgetId}/site/${siteId}`)
            .then(response => {
                
                this.setState((prevState) => {
                    return ({
                        ...prevState,
                        sites: response.data.sites
                    })
                })
                this.props.updateWidgetSites(widgetId, response.data.sites);
               
            })
            .catch(error => {
                console.error('Error deleting the site:', error);
                this.updateErrorMessage(error.response.data, "")
            });
    }

    render () {

        let {sites, displayPopup, error,isOpen} = this.state;
        return (
            <div className={'mjwi-popup mjwi-sites-pp' + (displayPopup ? '' : ' mjwi-hidden')}>
                <h2 style={{color : "black"}}>Installations</h2>
                    <table className="mjwi-table" border="1">
                        <thead className='mjwi-table-head'>
                            <tr>
                                <th>Domain</th>
                                <th>Last Used</th>
                                {isOpen && <th>Delete</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {sites.length > 0 ? (
                                sites.map(site => (
                                    <tr key={site.id}>
                                        <td>{site.domain === "null" ? "-" : site.domain}</td>
                                        <td>{formatDate(site.lastSeen)}</td>
                                        {isOpen && <td>
                                            <i
                                                onClick={() => { this.deleteSite(site._id) }}
                                                className="fa-solid fa-trash"
                                            ></i>
                                        </td>}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">
                                        No installations found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                <div className="mjwi-ct-card-btns">
                    <Button name="Close" eventHandler={() => {this.closePopup()}} />
                </div>
                <div className={'mjwi-error' + (error ? '' : ' mjwi-hidden')}>{error}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            overlay: state.overlay,
        }
    )
  }
  
  const mapDispatchToProps = (dispatch) => {
    return (
        {
            changeOverlayStatus: (status) => {dispatch(changeOverlayStatus(status))},
        }
    )
  }
  
  export default connect(mapStateToProps,mapDispatchToProps,null, {forwardRef: true} )(InstalledSitesPopup);
  